import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { css } from 'styled-components';
import { unitStrict } from '../unit';

export interface BorderRadiusProps {
    r: number | string;
    brd: number | string;
    borderRadius: number | string;
}

export const borderRadius = (defaultValue?: BorderRadiusProps['borderRadius']): any => css`
    & {
        border-radius: ${prop(['r', 'brd', 'borderRadius'], defaultValue, unitStrict)};
    }
`;

borderRadius.clean = (props): any => cleanProps(props, ['r', 'brd', 'borderRadius']);
